<script>
    export let title = '';
    export let subtitle = '';
</script>

<div class="header-large-title" {...$$restProps}>
    <h1 class="title">{@html (title ? title : '<span class="placeholder col-7"></span>')}</h1>
    <h4 class="subtitle mt-0">{@html (title || subtitle ? subtitle : '<span class="placeholder col-5"></span>')}</h4>
</div>
